export default "__VITE_ASSET__BP1f4Lm___"